<template>
  <li>
    <base-card>
      <div class="projectItem">
        <header>
          <h3>{{ name }}</h3>
        </header>
        <p>{{ desc }}</p>
        <div class="projectAreas">
          <base-badge
            v-for="tag in type"
            :key="tag"
            :type="tag"
            :title="tag"
          ></base-badge>
        </div>
        <hr />
        <div class="dateNtype">
          <div class="date">
            <p>{{ date }}</p>
          </div>
          <div class="type">
            <base-badge :type="mode">{{ mode }}</base-badge>
          </div>
        </div>
        <hr />
        <div class="controls">
          <div class="left"><base-button link :to="detailLink" mode="flat">Detail</base-button></div>
          <div class="right"><base-button link :to="routeLink">Task</base-button></div>
        </div>
      </div></base-card
    >
  </li>
</template>

<script>
export default {
  props: ["id", "name", "desc", "type", "mode", "date"],
  computed:{
    routeLink(){
      return "/task/"+this.id;
    },
    detailLink(){
      return "/newProject/"+this.id+"?mode=detail";
    }
  }
};
</script>

<style scoped>
.dateNtype{}
.date{width:50%; display:inline-block; text-align:left;}
.type{width:50%; display:inline-block; text-align:right;}
.left{width:50%; display:inline-block; text-align:left;}
.right{width:50%; display:inline-block; text-align:right;}
.controls{}
.type section, .type section span{margin-right:0px;}
.right button{margin-right:0px;}
header {
  padding: 0px 10px;
  background: slateblue;
  color: #fff;
  float: left;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 25px;
}
li {
  display: inline-block;
  list-style: none;
  margin: 1%;
  max-width: 300px;
  width: 100%;
  float: left;
}
.projectAreas {
  text-align: left;
}
</style>
